import _ from 'lodash';
import React from 'react';
import { inject, observer } from 'mobx-react';


@observer
class MuzadoRadio extends React.Component {
	componentDidMount () {
/* TODO: COde herez?? */
	}

	render () {
		// if (playlistStore.isLoading || songsStore.isLoading) {

		// 	return (<div className="loading-spinner large"></div>);
		// }

		return (
			<div className="grid-x grid-padding-x">
				<div className="cell small-12 padding-left-1">
					<h3 data-ta="muzadoManageFansHeader">Muzado Radio</h3>
				</div>

				<div className="cell small-12">
					Coming soon!
				</div>
			</div>
		);
	}
}

export default MuzadoRadio;
